import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { loadCoupon } from "@/lib/couponStore";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { LocaleShowcase } from "@/components/landing/LocaleShowcase";
import { PhotoStrip } from "@/components/landing/PhotoStrip";
import { Marquee } from "@/components/landing/Marquee";
import { Steps } from "@/components/landing/Steps";
import { OfferForm } from "@/components/landing/OfferForm";
import { Conditions } from "@/components/landing/Conditions";
import { Footer } from "@/components/landing/Footer";
import { FunnelTracker } from "@/components/FunnelTracker";

const DEFAULTS = {
  discount_percent: 20,
  validity_days: 14,
  booking_url: "https://www.baianeira.it",
  extra_conditions: [],
  promo_end_date: "",
};

const getParam = (name) => {
  try {
    return new URLSearchParams(window.location.search).get(name) || "";
  } catch {
    return "";
  }
};

export default function Home() {
  const [settings, setSettings] = useState(DEFAULTS);
  const [coupon, setCoupon] = useState(null);
  const [savedCoupon, setSavedCoupon] = useState(null);
  const [adParams] = useState(() => ({
    gclid: getParam("gclid"),
    fbclid: getParam("fbclid"),
  }));

  useEffect(() => {
    const saved = loadCoupon();
    if (saved) setSavedCoupon(saved);
    api
      .get("/settings")
      .then((r) => setSettings({ ...DEFAULTS, ...r.data }))
      .catch(() => {
        if (saved) setCoupon({ ...saved, restored: true });
      });
  }, []);

  return (
    <main className="bg-[#050505]">
      <FunnelTracker />
      <Navbar bookingUrl={settings.booking_url} />
      <PhotoStrip />
      <Hero discount={settings.discount_percent} promoEndDate={settings.promo_end_date} bookingUrl={settings.booking_url} />
      <OfferForm
        settings={settings}
        coupon={coupon}
        setCoupon={setCoupon}
        savedCoupon={savedCoupon}
        adParams={adParams}
      />
      <LocaleShowcase />
      <Marquee />
      <Steps />
      <Conditions extra={settings.extra_conditions} discount={settings.discount_percent} validityDays={settings.validity_days} />
      <Footer />
    </main>
  );
}
